import { type FC, useMemo } from "react";
import { useMatchMinute } from "../../../../hooks/use-match-minute";
import { usePolls } from "../../../../hooks/use-polls";
import { useViewerAuth } from "../../../../hooks/use-viewer-auth";
import type { Post } from "../../../../types/post.types";
import PostHeader from "../../components/post-header/post-header";
import { usePostBroadcastContext } from "../../post-broadcast.context";
import * as PostsCSS from "../../posts.styles";
import PollDisplay from "./poll-display/poll-display";

type PollPostProps = {
	post: Post;
};

const PollPost: FC<PollPostProps> = ({ post }) => {
	const { broadcastId } = usePostBroadcastContext();
	const polls = usePolls(broadcastId);
	const minute = useMatchMinute(post.date, post.minute);
	const uid = useViewerAuth();

	const poll = useMemo(
		() => polls.find((p) => p.id === post.pollId),
		[polls, post.pollId],
	);

	if (!poll) return null;

	if (!broadcastId || !uid) {
		return null;
	}

	return (
		<PostsCSS.Post>
			<PostHeader time={minute} type={post.type} />
			<PollDisplay poll={poll} broadcastId={broadcastId} uid={uid} />
		</PostsCSS.Post>
	);
};

export default PollPost;
